<template>
	<div>
		<div class="sousuo" style="width: 100%">
			<div style="width: 450px" class="yl-flex flex_between">
				<Input placeholder="搜索商户名称" v-model="name" style="width: 300px">
				<i-button slot="append" icon="ios-search"></i-button>
				</Input>
				<Button class='ivu-btn-circle' type="primary" style="padding-left: 20px;" @click="search">搜索</Button>
				<Button class='ivu-btn-circle' style="padding-left: 20px;" @click="initSearch">重置</Button>
				<Button class='ivu-btn-circle' style="padding-left: 20px;"
					@click="()=>{monthConventModal = true}">查看月份转化</Button>
			</div>
		</div>
		<div class="multiple">
			<div class="child-div">时间区间</div>
			<RadioGroup v-model="timePeriod">
				<Radio label="0"><span>不限</span></Radio>
				<Radio label="1"><span>今日</span></Radio>
				<Radio label="2"><span>昨日</span></Radio>
				<Radio label="3"><span>本周</span></Radio>
				<Radio label="4"><span>上周</span></Radio>
				<Radio label="5"><span>本月</span></Radio>
				<Radio label="6"><span>上月</span></Radio>
				<Radio label="7"><span>自定义</span></Radio>
				<DatePicker :value="timePeriodDate" @on-change="timePeriodDateChange" type="daterange"
					placeholder="选择日期" style="width: 200px"></DatePicker>

			</RadioGroup>
		</div>

		<div style="width: 100% ;margin-top: 20px;">
			<Table stripe border :columns="columns" :data="datas" ref="table">
				<template slot-scope="{ row }" slot="start_0">
					<span>{{row.start_0}}</span>
					<div>
						<span>({{row.start_0_rate}})</span>
					</div>

				</template>
				<template slot-scope="{ row }" slot="start_1">
					<span>{{row.start_1}}</span>
					<div>
						<span>({{row.start_1_rate}})</span>
					</div>
				</template>
				<template slot-scope="{ row }" slot="start_2">
					<span>{{row.start_2}}</span>
					<div>
						<span>({{row.start_2_rate}})</span>
					</div>
				</template>
				<template slot-scope="{ row }" slot="start_3">
					<span>{{row.start_3}}</span>
					<div>
						<span>({{row.start_3_rate}})</span>
					</div>
				</template>
				<template slot-scope="{ row }" slot="start_4">
					<span>{{row.start_4}}</span>
					<div>
						<span>({{row.start_4_rate}})</span>
					</div>
				</template>
				<template slot-scope="{ row }" slot="start_5">
					<span>{{row.start_5}}</span>
					<div>
						<span>({{row.start_5_rate}})</span>
					</div>
				</template>
				<template slot-scope="{ row }" slot="threePlus">
					<span>{{row.start_4+row.start_5}}</span>
					<div>
						<span>({{row.start_3_plus_rate}})</span>
					</div>
				</template>
			</Table>
		</div>
		<Modal v-model="monthConventModal" width="1200" title="月份转化分析">
			<CompanyConvertAnalyse></CompanyConvertAnalyse>
		</Modal>
	</div>
</template>
<script>
	import {
		mapGetters
	} from "vuex";
	import {
		getAllMediumCode,
		getShopStatics
	} from "../../api/runSet";
	import CompanyConvertAnalyse from "../statistics/CompanyConvertAnalyse.vue"
	export default {
		name: "channel_statistics",
		components: {
			CompanyConvertAnalyse
		},

		data() {
			return {
				modal: false,
				name: '',
				timePeriod: '1',
				timePeriodDate: [],
				datas: [],
				monthConventModal: false,
				columns: [{
						"title": "名称",
						"key": "name",
						"align": "center",
						"width": 120,
						"fixed": 'left'
					},
					{
						"title": "成本",
						"key": "price",
						"align": "center",
						"width": 100,
						"sortable": true
					},
					{
						"title": "当月创收",
						"key": "current_repay_money",
						"align": "center",
						"width": 80,
						"sortable": true
					},
					{
						"title": "拓客创收",
						"key": "introduce_repay",
						"align": "center",
						"width": 80,
						"sortable": true
					},
					{
						"title": "总创收",
						"key": "history_repay_money",
						"align": "center",
						"width": 80,
						"sortable": true
					},
					{
						"title": "平均成本",
						"key": "average_cost",
						"align": "center",
						"width": 90,
						"sortable": true
					},
					{
						"title": "数量",
						"key": "nums",
						"align": "center",
						"width": 100,
						"sortable": true
					},
					{
						"title": "0星",
						"slot": "start_0",
						"align": "center",
						"width": 100,
						"sortable": true
					},
					{
						"title": "1星",
						"slot": "start_1",
						"align": "center",
						"width": 100,
					},
					{
						"title": "2星",
						"slot": "start_2",
						"align": "center",
						"width": 100
					},
					{
						"title": "2星+",
						"slot": "start_3",
						"align": "center",
						"width": 100
					},
					{
						"title": "3星",
						"slot": "start_4",
						"align": "center",
						"width": 100
					},
					{
						"title": "4星",
						"slot": "start_5",
						"align": "center",
						"width": 100,
					},
					{
						"title": "3星+",
						"slot": "threePlus",
						"align": "center",
						"width": 100,
					},
					{
						"title": "待跟进",
						"key": "status_2",
						"align": "center",
						"width": 75,
					},
					{
						"title": "跟进中",
						"key": "status_3",
						"align": "center",
						"width": 75,
					},
					{
						"title": "签约率",
						"key": "status_sign_rate",
						"align": "center",
						"width": 75,
					},
					{
						"title": "放款率",
						"key": "status_loan_rate",
						"align": "center",
						"width": 75,
					},
					{
						"title": "公共池",
						"key": "pool_nums",
						"align": "center",
						"width": 75,
					},
					{
						"title": "公海",
						"key": "sea_nums",
						"align": "center",
						"width": 60,
					},
					{
						"title": "已上门",
						"key": "the_door_nums",
						"align": "center",
						"width": 75,
					},
					{
						"title": "上门率",
						"key": "status_door_rate",
						"align": "center",
						"width": 75,
						"fixed": 'right'
					}
				],
			}
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted: function() {
			this.loadData();
			this.getList();
		},
		methods: {

			timePeriodDateChange(e) {
				this.timePeriodDate = e
			},
			initSearch() {
				this.name = '';
				this.timePeriod = 0;
				this.timePeriodDate = [];
			},
			async loadData() {
				let that = this;
				this.getList();
				// let data = {}
				// data.token = this.token;
				// let res = await getAllMediumCode(that, data);
			},
			async getList() {
				let that = this;
				var data = this.$data;
				data.token = this.token;
				let res = await getShopStatics(that, data);
				that.datas = res.data.list;
			},
			search() {
				this.getList();
			}
		},


	}
</script>
<style scoped lang="less">
	.red {
		color: red;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;

		.child-div {
			width: 70px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}

	.hong {
		color: #F56171;
		font-weight: bold;
	}

	.lan {
		color: #124386;
		font-weight: bold;
	}

	.sousuo {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.ivu-table-header thead tr th {
		text-align: center !important;
	}

	.ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	.ivu-table table {
		width: 100% !important;
	}

	.green-bg {
		background: #18bc9c;
	}

	.blue-bg {
		background: #54A1F3;
	}

	.person {
		font-size: 14px;
		color: white;
		border-radius: 50%;
		width: 22px;
		height: 20px;
	}

	.in-block {
		display: inline-block;
	}

	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #ff6699;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}
</style>